import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { MediaDetectionPropertiesComponent } from './media-detection-properties.component';

const WIDGETS = [
	CardComponentModule,
	ContainerComponentModule,
	TextComponentModule,
	InputComponentModule,
	AuthoringPropertyLabelComponentModule
];

const PIPES = [
	DisplayAuthoringPropertyPipe,
	IsRequiredPropertyPipe,
	InheritPipe,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS
	],
	declarations: [MediaDetectionPropertiesComponent],
	exports: [MediaDetectionPropertiesComponent]
})
export class MediaDetectionPropertiesComponentModule {

}
